import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot } from "vue";
export function render(_ctx, _cache) {
  return _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_ctx.$attrs)));
}